import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

const ModalInvoicePrint = () => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.printInvoices');
  const onClose = () => {
    closeSingleModal('printInvoices');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Imprimir invoices"
      height={'auto'}
      width={'65vw'}
      backgroundColor={'#ececec'}
    >
      <Form.Export.Invoice.Print />
    </Modal>
  );
};

export default ModalInvoicePrint;
